import { AppFunctionComponent } from "../../types"
import React from "react"
import Contact from "../../components/about/contact/contact.component"
import BlogFeaturedStories from "../../components/common/sections/custom/blog-featured-stories/blog-featured-stories.component"
import InnovationLab from "../../components/common/sections/custom/innovation-lab-form/innovation-lab.component"
import MuditaMomentModule from "../../components/common/sections/custom/mudita-moment-module/mudita-moment-module.component"
import MuditaStores from "../../components/common/sections/custom/mudita-stores/mudita-stores.component"
import MobileSubscriptionsChart from "../../components/community/sar-checker/mobile-subscriptions-chart/mobile-subscriptions-chart.component"
import SarCheckerHero from "../../components/community/sar-checker/sar-checker-hero.component"
import XRay from "../../components/community/sar-checker/x-ray"
import { CustomComponentBuilder, CustomComponentType } from "../../types"
import FullWidthImage from "../../components/common/sections/custom/full-width-image/full-width-image.component"
import { Config as StoresConfig } from "../../components/common/sections/custom/mudita-stores/mudita-stores.interface"
import { Config as QuickStartConfig } from "../../components/common/sections/custom/quick-start/quick-start.interface"
import QuickStart from "../../components/common/sections/custom/quick-start/quick-start.component"
import CustomForm from "../../components/common/sections/custom/custom-form/custom-form.component"
import { CustomFormConfig } from "../../components/common/sections/custom/custom-form/custom-form.interface"
import Testimonials from "../../components/common/sections/custom/testimonials/testimonials.component"
import { TestimonialsConfig } from "../../components/common/sections/custom/testimonials/testimonials.interface"
import QuickStartElement from "../../components/common/sections/custom/quick-start-element/quick-start-element.component"
import TextWithListSlider, {
  TextWithListSliderConfig,
} from "../../components/common/text-with-list.component"
import KompaktFitComparison from "../../components/common/sections/custom/kompakt-fit-comparison/kompakt-fit-comparison.component"
import { QuickStartSlider } from "../../components/common/sections/custom/quick-start-kompakt/QuickStartSlider"
import ReviewsEmbedGrid from "../../components/common/sections/custom/reviews-embed-grid/reviews-embed-grid.component"
import { ReviewsEmbedGridConfig } from "../../components/common/sections/custom/reviews-embed-grid/reviews-embed-grid.interface"

const CustomComponentResolver: AppFunctionComponent<CustomComponentBuilder> = ({
  custom,
  config,
  images,
}) => {
  switch (custom) {
    case CustomComponentType.InnovationLabForm:
      return <InnovationLab />
    case CustomComponentType.MuditaMomentModule:
      return <MuditaMomentModule />
    case CustomComponentType.BlogFeaturedStories:
      return <BlogFeaturedStories />
    case CustomComponentType.Contact:
      return <Contact />
    case CustomComponentType.SarCheckerHero:
      return <SarCheckerHero />
    case CustomComponentType.SarCheckerChart:
      return <MobileSubscriptionsChart />
    case CustomComponentType.SarCheckerSlider:
      return <XRay />
    case CustomComponentType.Stores:
      return (
        <MuditaStores
          config={config as unknown as StoresConfig}
          images={images}
        />
      )
    case CustomComponentType.FullWidthImage:
      return <FullWidthImage />
    case CustomComponentType.QuickStartMoment:
      return <QuickStart config={config as unknown as QuickStartConfig} />
    case CustomComponentType.QuickStartElement:
      return (
        <QuickStartElement config={config as unknown as QuickStartConfig} />
      )
    case CustomComponentType.CustomForm:
      return <CustomForm config={config as unknown as CustomFormConfig} />
    case CustomComponentType.Testimonials:
      return <Testimonials config={config as unknown as TestimonialsConfig} />
    case CustomComponentType.TextWithListSlider:
      if (!images) {
        return null
      }
      return (
        <TextWithListSlider
          config={config as unknown as TextWithListSliderConfig}
          images={images}
        />
      )
    case CustomComponentType.KompaktFit:
      return <KompaktFitComparison />
    case CustomComponentType.QuickStartKompaktSlider:
      return <QuickStartSlider />
    case CustomComponentType.ReviewsEmbedGrid:
      return (
        <ReviewsEmbedGrid
          config={config as unknown as ReviewsEmbedGridConfig}
        />
      )
    default:
      return null
  }
}

export default CustomComponentResolver
